<template>
  <div class="option-box">
    <el-button @click="isAdd = true" type="primary">新增用户</el-button>
  </div>
  <el-table :data="userList" border style="width: 100%">
    <el-table-column prop="nikeName" label="姓名" width="180">
    </el-table-column>
    <el-table-column prop="userName" label="账号" width="180">
    </el-table-column>
    <el-table-column prop="role" label="角色">
      <template #default="scope">
        <el-button
          v-for="i in scope.row.role"
          :key="i.role"
          type="text"
          size="small"
          >{{ i.roleName }}</el-button
        >
      </template>
    </el-table-column>
    <el-table-column prop="role" label="操作">
      <template #default="scope">
        <el-button @click="modifyFun(scope.row)" type="text" size="small"
          >修改角色</el-button
        >
      </template>
    </el-table-column>
  </el-table>

  <el-dialog title="修改角色" v-model="isModify">
    <el-checkbox-group v-model="modifyId" size="small">
      <el-checkbox
        v-for="i in roleList"
        :key="i.roleId"
        :label="i.roleId"
        border
        >{{ i.roleName }}</el-checkbox
      >
    </el-checkbox-group>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="isModify = false">取 消</el-button>
        <el-button type="primary" @click="submodifyFun">确 定</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog @close="closeFun" title="新增用户" v-model="isAdd">
    <el-form
      label-width="80px"
      :model="addForm"
    >
      <el-form-item label="姓名">
        <el-input v-model="addForm.nikeName"></el-input>
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model="addForm.userName"></el-input>
      </el-form-item>
      <el-form-item label="角色">
         <el-checkbox-group v-model="addForm.role" size="small">
        <el-checkbox
          v-for="i in roleList"
          :key="i.roleId"
          :label="i.roleId"
          border
          >{{ i.roleName }}</el-checkbox
        >
    </el-checkbox-group>
      </el-form-item>
    </el-form>
   
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="isAdd = false">取 消</el-button>
        <el-button type="primary" @click="subFun">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { getUserList, getRoleList } from "../http/api";
import { onMounted, reactive, toRefs } from "vue";
export default {
  setup() {
    let data = reactive({
      userList: [],
      modifyId: [],
      modifyData: {},
      isModify: false,
      roleList: [],
      isAdd: false,
      addForm: {
        userName: "",
        nikeName: "",
        role: [],
      },
    });
    onMounted(() => {
      getUserList().then((res) => {
        data.userList = res;
      });
      getRoleList().then((res) => {
        data.roleList = res;
      });
    });
    // let obj = reactive({
    //   name:'zhangsan',
    //   id:1
    // })
    // console.log(toRefs(obj))
    const modifyFun = (row) => {
      data.modifyData = row;
      // data.modifyId = row.role
      data.modifyId = [];
      row.role.forEach((e) => {
        data.modifyId.push(e.role);
      });
      data.isModify = true;
    };
    const submodifyFun = () => {
      // //toRaw将一个响应式数据转化成非相应式数据
      // let list = data.roleList;
      // //data.modifyId是当前用户新配置的角色id集合roleId roleName
      // let roles = list.filter((v) => data.modifyId.indexOf(v.roleId)!==-1);
      // data.modifyData.role = [];
      // roles.forEach((v) => {
      //   let obj = {
      //     rloe: v.roleId,
      //     roleName: v.roleName,
      //   };
        data.modifyData.role=getRrleArr(data.modifyId)
      // });
      data.isModify = false;
    };
    const subFun = ()=>{
      data.addForm.role = getRrleArr(data.addForm.role)
      data.userList.unshift({...data.addForm}) 
      data.isAdd = false;
    }

    const getRrleArr = (rolearr)=>{
         //toRaw将一个响应式数据转化成非相应式数据
      let list = data.roleList;
      //根据新增的用户的角色id筛选
      let roles = list.filter((v) => rolearr.indexOf(v.roleId)!==-1);
     let arr = [];
      roles.forEach((v) => {
        let obj = {
          rloe: v.roleId,
          roleName: v.roleName,
        };
       arr.push(obj);
      });
      return arr
    }
    const closeFun = ()=>{
      data.addForm = {
          userName: "",
        nikeName: "",
        role: [],
      }
    }
    return {
      ...toRefs(data),
      modifyFun,
      submodifyFun,
      subFun,
      closeFun
    };
  },
};
</script>
<style lang="scss" scoped>
.option-box{
  margin: 10px;
}
</style>

